import { render, staticRenderFns } from "./card-products-result.vue?vue&type=template&id=aafb07c0&"
import script from "./card-products-result.vue?vue&type=script&lang=js&"
export * from "./card-products-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports